export interface INickPrefixField {
    const?: string;
}
